import { render, staticRenderFns } from "./BulmaToast.vue?vue&type=template&id=07fa1906"
import script from "./BulmaToast.vue?vue&type=script&lang=js"
export * from "./BulmaToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports